(function () {
    const accordions = document.querySelectorAll('.faq__item--accordion');

    accordions.forEach(function(accordion){

        const thisButton = accordion.querySelector('button');
        const thisContent = accordion.querySelector('.accordion__content');
        const thisContentContainer = accordion.querySelector('.accordion__content-container');
        thisButton.addEventListener('click', function(){
            let open = thisButton.getAttribute('aria-expanded');

            if(open == 'false'){
                thisButton.setAttribute('aria-expanded', true);
                thisButton.classList.add('open');
                thisContent.classList.remove('hidden');
                thisContent.removeAttribute('hidden');
                thisContent.style.height = (thisContentContainer.offsetHeight + 20) + 'px';
            }else{
                thisButton.setAttribute('aria-expanded', false);
                thisButton.classList.remove('open');
                thisContent.classList.add('hidden');
                thisContent.setAttribute('hidden', '');
                thisContent.style.height = '0px';
            }
        });

    });

})();